import { Device, MetricField } from "@/__generated__/graphql";
import { FormValues } from "@features/createDeviceConfiguration/type/FormValues";
import { Grid } from "@mui/material";
import { Control } from "react-hook-form";
import SensorForm from "./SensorForm";

interface NormalDeviceFormProps {
  device: Device;
  control: Control<FormValues>;
  sensorLevelOptions: any[];
  sensorVelocityOptions: any[];
  sensorFlowOptions: any[];
  sensorLevel: any;
  sensorVelocity: any;
  sensorFlow: any;
}

const NormalDeviceForm = ({
  device,
  control,
  sensorLevelOptions,
  sensorVelocityOptions,
  sensorFlowOptions,
  sensorLevel,
  sensorVelocity,
  sensorFlow,
}: NormalDeviceFormProps) => {
  return (
    <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
      {device?.deviceTypeMeasurement?.level  == 1 && (
        <Grid item xs={12} md={6}>
          <SensorForm
            sensorType={MetricField.Level}
            control={control}
            options={sensorLevelOptions}
            selectedSensor={sensorLevel}
          />
        </Grid>
      )}
      
      {device?.deviceTypeMeasurement?.velocity  == 1 && (
        <Grid item xs={12} md={6}>
          <SensorForm
            sensorType={MetricField.Velocity}
            control={control}
            options={sensorVelocityOptions}
            selectedSensor={sensorVelocity}
          />
        </Grid>
      )}
      
      {device?.deviceTypeMeasurement?.flow  == 1 && (
        <Grid item xs={12} md={6}>
          <SensorForm
            sensorType={MetricField.Flow}
            control={control}
            options={sensorFlowOptions}
            selectedSensor={sensorFlow}
          />
        </Grid>
      )}
    </Grid>
  );
}

export default NormalDeviceForm;